module.exports = __webpack_public_path__ + "img/homepage_bg.52e27d31.png";